/**
 * OutputsSection — "what you produce": six artifact cards. Answers the
 * "certificate of attendance" objection from the audience research by
 * naming concrete, reviewable deliverables.
 */

import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Artifact {
  kindKey: string;
  titleKey: string;
  bodyKey: string;
}

const ARTIFACTS: Artifact[] = [
  { kindKey: "OutputsSection.roadmapKind", titleKey: "OutputsSection.roadmapTitle", bodyKey: "OutputsSection.roadmapBody" },
  { kindKey: "OutputsSection.projectKind", titleKey: "OutputsSection.projectTitle", bodyKey: "OutputsSection.projectBody" },
  { kindKey: "OutputsSection.writeupKind", titleKey: "OutputsSection.writeupTitle", bodyKey: "OutputsSection.writeupBody" },
  { kindKey: "OutputsSection.mapKind", titleKey: "OutputsSection.mapTitle", bodyKey: "OutputsSection.mapBody" },
  { kindKey: "OutputsSection.positioningKind", titleKey: "OutputsSection.positioningTitle", bodyKey: "OutputsSection.positioningBody" },
  { kindKey: "OutputsSection.prepKind", titleKey: "OutputsSection.prepTitle", bodyKey: "OutputsSection.prepBody" },
];

export default function OutputsSection() {
  const { t } = useTranslation("home");
  return (
    <Box component="section">
      <Typography
        component="span"
        sx={{ fontSize: 14, fontWeight: 500, color: "secondary.main", display: "block", mb: 1 }}
      >
        {t("OutputsSection.eyebrow")}
      </Typography>
      <Typography component="h2" sx={{ fontSize: 32, fontWeight: 500, m: 0, mb: 4, maxWidth: "50ch" }}>
        {t("OutputsSection.heading")}
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        {ARTIFACTS.map((a) => (
          <Box
            key={a.kindKey}
            sx={{
              p: 3,
              borderRadius: "12px",
              border: 1,
              borderColor: "divider",
              bgcolor: "background.paper",
              transition: "border-color 0.15s, box-shadow 0.15s",
              "&:hover": { borderColor: "text.secondary", boxShadow: 1 },
            }}
          >
            <Typography
              component="span"
              sx={{
                fontFamily: '"JetBrains Mono", ui-monospace, monospace',
                fontSize: 12,
                fontWeight: 500,
                letterSpacing: "0.02em",
                color: "secondary.main",
              }}
            >
              {t(a.kindKey)}
            </Typography>
            <Typography component="h3" sx={{ fontSize: 19, fontWeight: 500, m: 0, mt: 1, mb: 0.75 }}>
              {t(a.titleKey)}
            </Typography>
            <Typography sx={{ fontSize: 14.5, color: "text.secondary" }}>
              {t(a.bodyKey)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
